<div class="payment-result-modal" *ngIf="paymentCompleted" (click)="closePaymentResult()">
  <div class="payment-result-popup" (click)="$event.stopPropagation()">
    <div class="payment-result-header">
      <div class="payment-status-icon">
        <svg *ngIf="paymentResponse?.isSuccess" width="48" height="48" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="32" fill="#10B981" />
          <path d="M20 32L28 40L44 24" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

        <svg *ngIf="!paymentResponse?.isSuccess" width="48" height="48" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="32" fill="#EF4444" />
          <path d="M24 24L40 40M40 24L24 40" stroke="white" stroke-width="3" stroke-linecap="round" />
        </svg>
      </div>
    </div>

    <div class="payment-result-content">
      <h2 class="payment-title" [ngClass]="{ success: paymentResponse?.isSuccess, failure: !paymentResponse?.isSuccess }">
        {{ this.message?.title }}
      </h2>
      <p>{{ this.message?.body }}</p>
      <div class="payment-details" *ngIf="paymentResponse?.isSuccess && paymentResponse?.chargedAmount != null && paymentResponse?.chargedAmount > 0">
        <div class="payment-detail-item">
          <span class="label">Amount ${{ paymentResponse?.chargedAmount }} | Transaction ID: {{ paymentResponse?.transactionID }}</span>
        </div>
      </div>

      <div class="payment-actions">
        <button *ngIf="bookAppointmentMerged() && showStartOverButton" class="btn btn--primary" (click)="loadPaymentSetup()">Start Over</button>
      </div>
    </div>
  </div>
</div>

<div class="popup-content-outer" *ngIf="!paymentCompleted">
  <div class="available-credit-card-outer">
    <div class="available-credit-card-outer__header">
      <h2 *ngIf="dialogConfig">{{ dialogTitle() }}</h2>
      <div class="available-credit-card-outer__amounts" *ngIf="flowTypeMerged() === paymentFlowType.PayOnly || flowTypeMerged() === paymentFlowType.PayAndSave">
        Amount to Collect: <span class="amount">${{ paymentData()?.paymentAmount }}</span>
      </div>
    </div>

    <div class="available-credit-card-outer__body">
      <div *ngIf="selectedPaymentMethod === 'existing' && paymentData()?.paymentCard != null" class="existing-card-section">
        <div class="section-header">
          <h4>Credit Card Details</h4>
          <a (click)="loadPaymentSetup()" href="javascript:void(0)" class="add-card" pTooltip="Add Credit Card" tooltipPosition="left" alt="Add card">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10ZM10.625 5.625C10.625 5.45924 10.5592 5.30027 10.4419 5.18306C10.3247 5.06585 10.1658 5 10 5C9.83424 5 9.67527 5.06585 9.55806 5.18306C9.44085 5.30027 9.375 5.45924 9.375 5.625V9.375H5.625C5.45924 9.375 5.30027 9.44085 5.18306 9.55806C5.06585 9.67527 5 9.83424 5 10C5 10.1658 5.06585 10.3247 5.18306 10.4419C5.30027 10.5592 5.45924 10.625 5.625 10.625H9.375V14.375C9.375 14.5408 9.44085 14.6997 9.55806 14.8169C9.67527 14.9342 9.83424 15 10 15C10.1658 15 10.3247 14.9342 10.4419 14.8169C10.5592 14.6997 10.625 14.5408 10.625 14.375V10.625H14.375C14.5408 10.625 14.6997 10.5592 14.8169 10.4419C14.9342 10.3247 15 10.1658 15 10C15 9.83424 14.9342 9.67527 14.8169 9.55806C14.6997 9.44085 14.5408 9.375 14.375 9.375H10.625V5.625Z"
                fill="#6F64A7"
              />
            </svg>
          </a>
        </div>

        <div class="card-details">
          <span class="box-row"> <strong>Last 4 Digits:</strong> {{ paymentData()?.paymentCard?.maskedCardNumber }} </span>
          <span class="box-row">
            <strong>Expiry Date:</strong> {{ paymentData()?.paymentCard?.expirationMonth }} / {{ paymentData()?.paymentCard?.expirationYear }}
          </span>
        </div>

        <div class="radio-option" *ngIf="paymentData()?.paymentCard != null">
          <input type="radio" id="existing-card" name="paymentMethod" value="existing" [(ngModel)]="selectedPaymentMethod" class="hidden-radio" />
          <label for="existing-card" class="credit-card-box">
            <div class="radio-indicator">
              <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="20" height="20" rx="10" fill="white" stroke="#6F64A7" />
                <rect x="5" y="5" width="11" height="11" rx="5.5" fill="#6F64A7" />
              </svg>
            </div>
            <div class="card-info">
              <strong>Use Existing Credit Card</strong>
            </div>
            <div class="card-icons">
              <svg width="38" height="23" viewBox="0 0 38 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_25415_46407)">
                  <path
                    d="M11.704 0C8.59314 0.00986008 5.6134 1.22836 3.41902 3.38797C1.22465 5.54758 -0.0050184 8.47179 1.53942e-05 11.5185C0.00504919 14.5653 1.24437 17.4856 3.44587 19.6382C5.64738 21.7909 8.63112 22.9999 11.742 22.9999C14.8529 22.9999 17.8366 21.7909 20.0381 19.6382C22.2396 17.4856 23.4789 14.5653 23.484 11.5185C23.489 8.47179 22.2594 5.54758 20.065 3.38797C17.8706 1.22836 14.8909 0.00986008 11.78 0L11.704 0Z"
                    fill="#EB001B"
                  />
                  <path
                    d="M26.2201 0C23.1092 0.00986008 20.1295 1.22836 17.9351 3.38797C15.7408 5.54758 14.5111 8.47179 14.5161 11.5185C14.5212 14.5653 15.7605 17.4856 17.962 19.6382C20.1635 21.7909 23.1472 22.9999 26.2581 22.9999C29.369 22.9999 32.3527 21.7909 34.5542 19.6382C36.7557 17.4856 37.9951 14.5653 38.0001 11.5185C38.0051 8.47179 36.7755 5.54758 34.5811 3.38797C32.3867 1.22836 29.407 0.00986008 26.2961 0L26.2201 0Z"
                    fill="#F79E1B"
                  />
                  <path
                    d="M19.0001 2.4563C17.6014 3.53232 16.4705 4.9055 15.6929 6.47216C14.9153 8.03882 14.5112 9.75802 14.5112 11.5C14.5112 13.242 14.9153 14.9612 15.6929 16.5278C16.4705 18.0945 17.6014 19.4677 19.0001 20.5437C20.3988 19.4677 21.5297 18.0945 22.3073 16.5278C23.0849 14.9612 23.489 13.242 23.489 11.5C23.489 9.75802 23.0849 8.03882 22.3073 6.47216C21.5297 4.9055 20.3988 3.53232 19.0001 2.4563Z"
                    fill="#FF5F00"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_25415_46407">
                    <rect width="38" height="23" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </label>
        </div>
      </div>

      <div class="new-card-section" *ngIf="paymentData()?.paymentCard === null || isReplaceCard">
        <div class="radio-option" *ngIf="paymentData()?.paymentCard != null && isReplaceCard">
          <input type="radio" id="new-card" name="paymentMethod" value="new" [(ngModel)]="selectedPaymentMethod" class="hidden-radio" />
          <label for="new-card" class="credit-card-box">
            <div class="radio-indicator">
              <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="20" height="20" rx="10" fill="white" stroke="#6F64A7" />
                <rect x="5" y="5" width="11" height="11" rx="5.5" fill="#6F64A7" />
              </svg>
            </div>
            <div class="card-info">
              <strong>Add New Credit Card</strong>
            </div>
            <div class="card-icons">
              <!-- <svg width="38" height="23" viewBox="0 0 38 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_25415_46407)">
                  <path
                    d="M11.704 0C8.59314 0.00986008 5.6134 1.22836 3.41902 3.38797C1.22465 5.54758 -0.0050184 8.47179 1.53942e-05 11.5185C0.00504919 14.5653 1.24437 17.4856 3.44587 19.6382C5.64738 21.7909 8.63112 22.9999 11.742 22.9999C14.8529 22.9999 17.8366 21.7909 20.0381 19.6382C22.2396 17.4856 23.4789 14.5653 23.484 11.5185C23.489 8.47179 22.2594 5.54758 20.065 3.38797C17.8706 1.22836 14.8909 0.00986008 11.78 0L11.704 0Z"
                    fill="#EB001B" />
                  <path
                    d="M26.2201 0C23.1092 0.00986008 20.1295 1.22836 17.9351 3.38797C15.7408 5.54758 14.5111 8.47179 14.5161 11.5185C14.5212 14.5653 15.7605 17.4856 17.962 19.6382C20.1635 21.7909 23.1472 22.9999 26.2581 22.9999C29.369 22.9999 32.3527 21.7909 34.5542 19.6382C36.7557 17.4856 37.9951 14.5653 38.0001 11.5185C38.0051 8.47179 36.7755 5.54758 34.5811 3.38797C32.3867 1.22836 29.407 0.00986008 26.2961 0L26.2201 0Z"
                    fill="#F79E1B" />
                  <path
                    d="M19.0001 2.4563C17.6014 3.53232 16.4705 4.9055 15.6929 6.47216C14.9153 8.03882 14.5112 9.75802 14.5112 11.5C14.5112 13.242 14.9153 14.9612 15.6929 16.5278C16.4705 18.0945 17.6014 19.4677 19.0001 20.5437C20.3988 19.4677 21.5297 18.0945 22.3073 16.5278C23.0849 14.9612 23.489 13.242 23.489 11.5C23.489 9.75802 23.0849 8.03882 22.3073 6.47216C21.5297 4.9055 20.3988 3.53232 19.0001 2.4563Z"
                    fill="#FF5F00" />
                </g>
                <defs>
                  <clipPath id="clip0_25415_46407">
                    <rect width="38" height="23" fill="white" />
                  </clipPath>
                </defs>
              </svg> -->
            </div>
          </label>
        </div>

        <div class="new-card-form" *ngIf="selectedPaymentMethod === 'new' || paymentData()?.paymentCard === null">
          <div class="form-header">
            <!-- <h4>Credit Card Details</h4> -->
            <a
              *ngIf="paymentData()?.paymentCard != null"
              (click)="switchToExistingCard()"
              href="javascript:void(0)"
              class="remove-card"
              pTooltip="Use Existing Card"
              tooltipPosition="left"
              alt="Switch to existing card"
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10ZM5.625 9.375C5.45924 9.375 5.30027 9.44085 5.18306 9.55806C5.06585 9.67527 5 9.83424 5 10C5 10.1658 5.06585 10.3247 5.18306 10.4419C5.30027 10.5592 5.45924 10.625 5.625 10.625H14.375C14.5408 10.625 14.6997 10.5592 14.8169 10.4419C14.9342 10.3247 15 10.1658 15 10C15 9.83424 14.9342 9.67527 14.8169 9.55806C14.6997 9.44085 14.5408 9.375 14.375 9.375H5.625Z"
                  fill="#6F64A7"
                />
              </svg>
            </a>

            <app-timer-payment *ngIf="paymentSetup" (timeoutExpired)="onTimeoutExpired()"></app-timer-payment>
          </div>

          <p class="form-description" *ngIf="paymentData()?.paymentCard != null && isReplaceCard">
            New card details will replace your existing card, or be added if card is not available on file.
          </p>

          <div class="iframe-container" *ngIf="hostedPaymentUrl">
            <iframe [src]="hostedPaymentUrl" width="100%" height="600" frameborder="0"></iframe>
          </div>

          <div *ngIf="loading" class="loading-container">
            <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="8" fill="#6F64A7" animationDuration=".8s"></p-progressSpinner>
            <p>Loading payment form...</p>
          </div>
        </div>
      </div>
    </div>

    <div class="available-credit-card-outer__footer" *ngIf="selectedPaymentMethod === 'existing'">
      <button *ngIf="dialogConfig" class="btn btn--secondary" (click)="cancelDialog()">Cancel</button>
      <button class="btn btn--primary" type="submit" [disabled]="!selectedPaymentMethod" (click)="chargeCard()">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.6499 20.65C9.33668 20.65 8.03632 20.3913 6.82307 19.8888C5.60981 19.3862 4.50742 18.6496 3.57883 17.7211C2.65025 16.7925 1.91365 15.6901 1.41111 14.4768C0.90856 13.2636 0.649902 11.9632 0.649902 10.65C0.649902 9.33677 0.90856 8.03642 1.41111 6.82316C1.91365 5.6099 2.65025 4.50751 3.57883 3.57893C4.50742 2.65034 5.60981 1.91375 6.82307 1.4112C8.03632 0.908651 9.33668 0.649994 10.6499 0.649994C13.3021 0.649994 15.8456 1.70356 17.721 3.57893C19.5963 5.45429 20.6499 7.99783 20.6499 10.65C20.6499 13.3022 19.5963 15.8457 17.721 17.7211C15.8456 19.5964 13.3021 20.65 10.6499 20.65Z"
            fill="white"
          />
          <path
            d="M5.6499 10.65L9.93562 14.2214L15.6499 7.07857M10.6499 20.65C9.33668 20.65 8.03632 20.3913 6.82307 19.8888C5.60981 19.3862 4.50742 18.6496 3.57883 17.7211C2.65025 16.7925 1.91365 15.6901 1.41111 14.4768C0.90856 13.2636 0.649902 11.9632 0.649902 10.65C0.649902 9.33678 0.90856 8.03642 1.41111 6.82316C1.91365 5.6099 2.65025 4.50751 3.57883 3.57893C4.50742 2.65034 5.60981 1.91375 6.82307 1.4112C8.03632 0.908651 9.33668 0.649994 10.6499 0.649994C13.3021 0.649994 15.8456 1.70356 17.721 3.57893C19.5963 5.45429 20.6499 7.99783 20.6499 10.65C20.6499 13.3022 19.5963 15.8457 17.721 17.7211C15.8456 19.5964 13.3021 20.65 10.6499 20.65Z"
            stroke="#6F64A7"
            stroke-width="1.3"
          />
        </svg>
        {{ buttonText }}
      </button>
    </div>
  </div>
</div>

<div class="full-screen-loader" *ngIf="loadingCustom && !paymentCompleted">
  <div class="full-screen-loader__outer">
    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 27C0 19.8392 2.84463 12.9716 7.90812 7.90812C12.9716 2.84463 19.8392 0 27 0C34.1608 0 41.0284 2.84463 46.0919 7.90812C51.1554 12.9716 54 19.8392 54 27C54 34.1608 51.1554 41.0284 46.0919 46.0919C41.0284 51.1554 34.1608 54 27 54C19.8392 54 12.9716 51.1554 7.90812 46.0919C2.84463 41.0284 0 34.1608 0 27H0ZM25.4592 38.556L41.004 19.1232L38.196 16.8768L24.9408 33.4404L15.552 25.6176L13.248 28.3824L25.4592 38.5596V38.556Z"
      />
    </svg>
    <h3>Progress..!</h3>
    <p>Your Appointment booking is in progress...</p>
  </div>
</div>
